import Api from '@/api/api.js'
import api_caisse from '@/api/config/_api_caisse'

export default {
    /**
     * Liste des articles
     */
    allArticles() {
        const promise = Api().get("/all_articles");
        return promise.then((response) => response.data);
    },

    getListeArticle() {
        const promise = Api().get("/articles/all_articles");
        return promise.then((response) => response.data);
    },
    
    getAllListesArticles() {
        const promise = Api().get("/articles/listes_articles");
        return promise.then((response) => response.data);
    },

    /**
     * Liste des articles
     */
    articles() {
        const promise = Api().get("/articles");
        return promise.then((response) => response.data);
    },

    /**
     * Enregistrer un article
     * @param {*} data
     */
    saveArticle(data) {
        const promise = Api().post("/articles", data);
        return promise.then((response) => response);
    },

    /**
     * Recuperer l'article dont l'id est passer en paramètre
     * @param int id
     */
    getArticle(data) {
        const promise = Api().post("/article/" + data.article_id, data);
        return promise.then((response) => response.data);
    },

    /**
     * Modifier l'article dont l'id est passé en paramètre
     * @param {*} id
     * @param {*} data
     */
    editArticle(id, data) {
        const promise = Api().put("/article/" + id, data);
        return promise.then((response) => response);
    },

    /**
     * Supprimer l'article dont l'id est passé en paramètre
     * @param int id
     */
    deleteArticle(id) {
        const promise = Api().delete("/articles/" + id);
        return promise.then((response) => response.data);
    },

    /**
     * Liste des articles supprimer
     */
    deletedArticles() {
        const promise = Api().get("/articles/deleted");
        return promise.then((response) => response.data);
    },

    /**
     * liste des articles en ruptures de stock
     */
    rupturesArticles() {
        const promise = Api().get("/articles/ruptures");
        return promise.then((response) => response.data);
    },

    /**
     * Liste des articles en peremption
     */
    peremptionsArticles() {
        const promise = Api().get("/articles/peremptions");
        return promise.then((response) => response.data);
    },

    getRecapStock(data) {
        const promise = Api().post('/articles/recap-produit', data)
        return promise.then(response => response.data)
    },

    getListeArticeACommander() {
        const promise = Api().get('/articles/liste-article-a-commander')
        return promise.then(response => response.data)
    },

    getMonthlyConsumption(data) {
        const promise = Api().post('/stocks/recap-consommations-mensuelles', data)
        return promise.then(response => response.data)
    },

    getRecapSortieStock(data) {
        const promise = api_caisse().post('/stocks/liste-sortie-articles', data)
        return promise.then(response => response.data)
    },
};